<template>
    <div id="BannerSection">
      <Header/>
      <v-container fluid>
        <v-card class="w-100">
          <v-card-title>
            단골이 늘면<br/>
            매출UP! 대출한도 UP!
          </v-card-title>
          <v-card-subtitle>
            <span>오늘의 식당</span>은 우리 동네 숨은<br/>
            고객을 찾아주고 상점에 방문하는 고객을<br/>
            <span>단골로 만들어 주는 서비스</span> 입니다.
          </v-card-subtitle>
        </v-card>
      </v-container>
  </div>
</template>

<script>
import Header from './Header'

export default {
  name: 'BannerSection',
  components: {
    Header
  },
  data() {
    return {
      phone: ''
    }
  },
  methods: {
    submit() {
      alert('신청되었습니다.')
    },
    inputPhoneNum() {
      let phone = this.phone
      if (phone != null && phone.length > 0) {
        this.phone = phone.replace(/[^\d]/g, '')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  #BannerSection {
    background: url( '../../../assets/images/todaystore/bg-bg-tr-top-568@3x.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 78vh;
    padding-left: 7.82vw;
    padding-right: 7.82vw;
    .container {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      width: auto;
    }
    .v-card {
      box-shadow: none;
      background: transparent;
      &__title {
        font-size: 1.9rem;
        font-weight: 800;
        line-height: 1.43;
        letter-spacing: -0.43px;
        padding-left: 0;
        padding-right: 0;
      }
      &__subtitle {
        color: #262422;
        font-size: 1.13rem;
        margin-top: 2.5%;
        letter-spacing: -0.66px;
        line-height: 1.5;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0;
        span {
          font-weight: 800;
        }
      }
    }
  }
</style>
